import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M7.8125 2C4.60156 2 2 4.60156 2 7.8125C2 11.0234 4.60156 13.625 7.8125 13.625C11.0234 13.625 13.625 11.0234 13.625 7.8125C13.625 4.60156 11.0234 2 7.8125 2ZM12.875 7.8125C12.875 10.6016 10.6016 12.875 7.8125 12.875C5.02344 12.875 2.75 10.625 2.75 7.8125C2.75 5.04688 5 2.75 7.8125 2.75C10.5781 2.75 12.875 5.02344 12.875 7.8125Z',
];
export const RadioOff = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
RadioOff.iconCategory = 'toggle';
